import {useSelector} from "react-redux";
import ButtonV2 from "../../../shared/button-v2/button-v2"
import users from "../../../users";
import {cn} from "../../../../utils/utils";
import useViewTMDBContent from "../../hooks/useViewTMDBContent";

import "../episodeDetails/episodeDetails.css";

type Props = {
    item: any;
    forceDarkMode?: "light" | "dark";
}

const TmdbViewToggle = ({item, forceDarkMode}: Props) => {

    const darkTheme = useSelector(users.selectors.isDarkMode);
    const {markThingAsView} = useViewTMDBContent();

    return (
        <>

            {!item.view && <ButtonV2
                forceDarkMode={forceDarkMode}
                width={50}
                title="Marcar como visto"
                onClick={() => markThingAsView(true)}>
                <i className={cn("fa-solid fa-eye fa-lg icon-set-as-view",
                    {"icon-set-as-view__dark": darkTheme})}>

                </i>
            </ButtonV2>}
            {!!item.view && <ButtonV2
                forceDarkMode={forceDarkMode}
                width={50}
                title="Desmarcar"
                onClick={() => markThingAsView(false)}>
                <i className={cn("fa-solid fa-check-double fa-lg icon-no-view",
                    {"icon-no-view__dark": darkTheme})}></i>
            </ButtonV2>}
        </>
    )
}

export default TmdbViewToggle;
